// NEW_FILE_JUSTIFIED: Control page wrappers extracted to dedicated file following PageWrappers.tsx pattern
import { AppLayoutMemo } from '@/components/layout';
import { ControlDashboardPage } from '@/pages/control/ControlDashboardPage';
import { UsersManagementPage } from '@/pages/control/UsersManagementPage';
import { OrganisationsManagementPage } from '@/pages/control/OrganisationsManagementPage';
import { OrgDetailPage } from '@/pages/control/OrgDetailPage';
import { PolicyTemplatesPage } from '@/pages/control/PolicyTemplatesPage';
import { TemplateDetailPage } from '@/pages/control/TemplateDetailPage';
import { AuditLogPage } from '@/pages/control/AuditLogPage';
import { OrgPolicyStatsPage } from '@/pages/control/OrgPolicyStatsPage';

export function ControlDashboardPageWrapper() {
  return (
    <AppLayoutMemo>
      <ControlDashboardPage />
    </AppLayoutMemo>
  );
}

export function UsersManagementPageWrapper() {
  return (
    <AppLayoutMemo>
      <UsersManagementPage />
    </AppLayoutMemo>
  );
}

export function OrganisationsManagementPageWrapper() {
  return (
    <AppLayoutMemo>
      <OrganisationsManagementPage />
    </AppLayoutMemo>
  );
}

export function OrgDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <OrgDetailPage />
    </AppLayoutMemo>
  );
}

export function PolicyTemplatesPageWrapper() {
  return (
    <AppLayoutMemo>
      <PolicyTemplatesPage />
    </AppLayoutMemo>
  );
}

export function TemplateDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <TemplateDetailPage />
    </AppLayoutMemo>
  );
}

export function AuditLogPageWrapper() {
  return (
    <AppLayoutMemo>
      <AuditLogPage />
    </AppLayoutMemo>
  );
}

export function OrgPolicyStatsPageWrapper() {
  return (
    <AppLayoutMemo>
      <OrgPolicyStatsPage />
    </AppLayoutMemo>
  );
}
